import React from 'react'

import scriptjs from 'scriptjs'

export const withScriptJs = (url) => (Component) => {
  class WithScriptJsHOC extends React.Component {
    state = {
      scriptLoaded: false,
    }
    componentDidMount() {
      scriptjs(url, () => {
        this.setState({
          scriptLoaded: true,
        })
      })
    }
    render() {
      return this.state.scriptLoaded ? <Component {...this.props} /> : null
    }
  }
  return WithScriptJsHOC
}
